import { gql } from '@apollo/client';

export const GET_SLACK_CHANNELS = gql`
  query slackChannels {
    slackChannels {
      userName
      channels {
        name
        id
      }
    }
    slackAuthApi
    slackClientId
  }
`;

export const DELETE_SLACK_CHANNEL = gql`
  mutation deleteSlackChannel($channelInfo:  SlackChannelInfoInput!) {
    deleteSlackChannel(channelInfo: $channelInfo) {
      id
    }
  }
`;

export const UPLOAD_IMAGE_TO_SLACK = gql`
  mutation uploadImageToSlackChannels($channelIds: [String!]!, $image: ImageFileInput!, $initialComment: String!) {
    uploadImageToSlackChannels(channelIds: $channelIds, image: $image, initialComment: $initialComment)
  }
`;
